'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'book-bookmark';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e0bb';
var svgPathData = ['M0 0l192 0 0 224 80-64 80 64 0-224 96 0 0 384-32 0 0 64 32 0 0 64-448 0 0-512zM64 416l0 32 288 0 0-64-256 0c-17.7 0-32 14.3-32 32z', 'M192 224l0-224 160 0 0 224-80-64-80 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookBookmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;